import Video from "../../services/Video";
import useAuthorizedQuery from "../../common/hooks/useAuthorizedQuery";

export const QUERY_KEY = "videos";

function useListVideos({ enabled = true } = {}) {
  return useAuthorizedQuery(QUERY_KEY, () => Video.listVideos(), { enabled });
}

export default useListVideos;
